module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "widget__content"
  }, [(_vm.content.title) ? _c('div', {
    ref: "title",
    staticClass: "widget__title"
  }, [_vm._v(_vm._s(_vm.content.title))]) : _vm._e(), _c('div', {
    directives: [{
      name: "md",
      rawName: "v-md",
      value: (_vm.content.content),
      expression: "content.content"
    }],
    ref: "content",
    staticClass: "widget__main markdown-container"
  }), _c('div', {
    staticClass: "widget__main markdown-container"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35f34312","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/post/widgets/text.vue
// module id = 475
// module chunks = 0